// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"image_shadow__3J7C-","image":"image_image__2-6qS"};